import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InfoModalComponent } from '../../../../components/info-modal/info-modal.component';
import { CommonEnums } from '../../../../enums/comman.enums';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-unlock-nft',
  templateUrl: './unlock-nft.component.html'
})
export class UnlockNftComponent implements OnInit {
  constructor(private readonly modalService: BsModalService,
    public readonly cs: CommonService,
  ) {}

  ngOnInit() {
    if (this.cs.isBrowser) {
      this.modalService.show(InfoModalComponent, {
        initialState: {
          heading: CommonEnums.UNLOCK_NFT_STEPS,
          showCrossBtn: false,
          description: CommonEnums.NFT_STEPS_DESCRIPTION,
          iconStyleClass: 'confirm-creator-icon-bg',
          buttonField: {
            type: 'button',
            class: 'btn btn-primary',
            label: CommonEnums.OK
          }
        },
        class: 'modal-lg livestream-payment-modal',
        backdrop: 'static'
      });
    }
  }

  closeDialog() {
    this.modalService.hide();
  }
}
